<template>
  <div class="fancy-success">
    <icon-success />
  </div>
</template>